import * as Linking from 'expo-linking';
import { Platform } from 'react-native';
import { cannyAppID, feedbackAndRoadmapUrl } from '../utils/constants';
import { useLoadedUser } from './api/useUser';
import getName from '../utils/getName';
import React from 'react';

export type UseRedirectToFeedbackAndRoadmapReturnValue = {
    redirectToFeedbackAndRoadmap: () => void;
    isRedirecting: boolean;
};

export function useRedirectToFeedbackAndRoadmap(): UseRedirectToFeedbackAndRoadmapReturnValue {
    const [isRedirecting, setIsRedirecting] = React.useState(false);

    const user = useLoadedUser({});
    return {
        redirectToFeedbackAndRoadmap: () => {
            const fallbackToNonIdentifiedCanny = () => {
                Linking.openURL(feedbackAndRoadmapUrl);
            };

            if (Platform.OS !== 'web' || !(window as any).Canny) {
                fallbackToNonIdentifiedCanny();
                return;
            }

            async function loadCannyAndRedirect() {
                setIsRedirecting(true);
                await (window as any).Canny('identify', {
                    appID: cannyAppID,
                    user: {
                        email: user.user.email,
                        name: getName(user.user),
                        id: user.user.userId,
                    },
                });
                const link = document.createElement('a');
                link.setAttribute('data-canny-link', '');
                link.href = feedbackAndRoadmapUrl;
                link.innerText = 'Give feedback';

                // Append the link to the body
                document.body.appendChild(link);

                // Click the link
                link.click();

                // Remove the link from the DOM
                document.body.removeChild(link);
            }

            loadCannyAndRedirect()
                .catch((e) => {
                    console.error('Error loading Canny', e);
                    fallbackToNonIdentifiedCanny();
                })
                .finally(() => {
                    setIsRedirecting(false);
                });
        },
        isRedirecting: isRedirecting,
    };
}
